import * as React from 'react';

import OrganizationList from '../organization/organization-list';

const EmployeePage = () => (
  <div id="organizations" className="container">
    <OrganizationList />
  </div>
);

export default EmployeePage;
